import React from 'react'
import { Availability } from '@clear-denver/tpc-bff-client/build/api/tpc-bff/types'
import { Box, Text } from '@clear/design-system'
import { AccessibleLocation } from './AccessibleLocation'
import { ConversionCouponInfo } from './ConversionCouponInfo'
import { useConfigContext } from '@contexts/ConfigContext'

export interface LaneInfo {
  name: string
  description: string
  openDaily: boolean
  isAccessible: boolean
  accessibilityMessage: string
  availability: Availability[]
  id: string
  lastLane?: boolean
  conversionCouponInfo?: string
  importantInfo?: string
}

export const LaneInfo = ({
  name,
  description,
  openDaily,
  isAccessible,
  accessibilityMessage,
  availability,
  importantInfo,
  conversionCouponInfo,
  lastLane = false,
}: LaneInfo) => {
  const {
    config: {
      locations: { displayConversionCouponInfo },
    },
  } = useConfigContext()
  return (
    <>
      <Text my={1}>{name}</Text>
      <Text>{description}</Text>
      <Box mt={1}>
        {availability.map(({ hours, days }) => (
          <div key={hours} className="mb-1">
            {<Text mb={2}>{!days && openDaily ? 'Open Daily' : days}</Text>}{' '}
            <Text mb={2}>{hours}</Text>
          </div>
        ))}
        {importantInfo ? (
          <Text mb={3} color="utilityDarkErrorRed">
            {importantInfo}
          </Text>
        ) : null}
        {lastLane && conversionCouponInfo && displayConversionCouponInfo ? (
          <ConversionCouponInfo conversionCouponInfo={conversionCouponInfo} />
        ) : null}
      </Box>
      <AccessibleLocation
        isAccessible={isAccessible}
        accessibilityMessage={accessibilityMessage}
      />
    </>
  )
}
